import { render, staticRenderFns } from "./RestrictedModeAlerts.vue?vue&type=template&id=dbd83cfc&scoped=true&"
import script from "./RestrictedModeAlerts.vue?vue&type=script&lang=ts&"
export * from "./RestrictedModeAlerts.vue?vue&type=script&lang=ts&"
import style0 from "./RestrictedModeAlerts.vue?vue&type=style&index=0&id=dbd83cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd83cfc",
  null
  
)

export default component.exports